import React from "react";
import { motion } from "framer-motion";
import { WHERE_TO_PLAY } from "../../lib/assets";

// 8 tiles. Bento layout — feature tile + supporting tiles, no empty cells.
const layout = [
  "col-span-2 row-span-2",  // Airports (feature: 2×2)
  "col-span-1 row-span-1",  // Pubs
  "col-span-1 row-span-1",  // Cafés
  "col-span-2 row-span-1",  // Holidays (wide, next to Airports)
  "col-span-1 row-span-1",  // Festivals
  "col-span-1 row-span-1",  // Train Journeys
  "col-span-2 row-span-1",  // Cruises (wide)
  "col-span-2 md:col-span-4 row-span-1", // Campsites (full width bottom)
];

export const WhereToPlay = () => {
  return (
    <section
      id="where-to-play"
      data-testid="where-to-play-section"
      className="navy-bg grain py-12 md:py-28 text-white"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 items-end mb-8 md:mb-14 gap-4 md:gap-8">
          <div className="md:col-span-8">
            <p className="eyebrow mb-4" style={{ color: "var(--pw-yellow)" }}>
              Where To Play
            </p>
            <h2
              className="font-display font-black leading-[0.95] tracking-tighter"
              style={{ fontSize: "clamp(2rem, 5.5vw, 4.75rem)" }}
            >
              Anywhere with
              <br />
              <span className="yellow-stroke">humans nearby.</span>
            </h2>
          </div>
          <p className="md:col-span-4 text-white/75 leading-relaxed">
            Airports, pubs, cafés, holidays, festivals, trains, cruises, campsites — if there are
            people around, there&apos;s a game.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[100px] md:auto-rows-[200px] gap-3 md:gap-4">
          {WHERE_TO_PLAY.map((p, i) => (
            <motion.div
              key={p.location}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 6) * 0.06 }}
              data-testid={`where-tile-${p.location.toLowerCase().replace(/\s+/g, "-")}`}
              className={`group relative overflow-hidden rounded-2xl ${layout[i] || "col-span-1 row-span-1"}`}
            >
              <img
                src={p.url}
                alt={`${p.location} — where People Watching gets played`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div
                className="absolute inset-0 opacity-90 mix-blend-multiply transition-opacity duration-500"
                style={{ backgroundColor: "rgba(14,26,43,0.35)" }}
              />
              <div
                className="hover-only-effect absolute inset-0 opacity-0 group-hover:opacity-95 transition-opacity duration-500 flex items-center justify-center"
                style={{ backgroundColor: "var(--pw-yellow)" }}
              >
                <span
                  className="font-display font-black text-center px-4 tracking-tighter"
                  style={{
                    color: "var(--pw-navy)",
                    fontSize: "clamp(1.25rem, 2.6vw, 2.5rem)",
                  }}
                >
                  {p.location}
                </span>
              </div>
              <span
                className="absolute bottom-4 left-4 font-display text-white text-lg md:text-2xl font-bold tracking-tight drop-shadow-md group-hover:opacity-0 transition-opacity"
              >
                {p.location}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhereToPlay;
